// ============================================================
// Authentication API Types (Requests)
// ============================================================
export var DeviceScopeMask;
(function (DeviceScopeMask) {
    DeviceScopeMask[DeviceScopeMask["STREAM_LISTEN"] = 1] = "STREAM_LISTEN";
    DeviceScopeMask[DeviceScopeMask["MESSAGES_READ"] = 2] = "MESSAGES_READ";
    DeviceScopeMask[DeviceScopeMask["SPOOL_DRAIN"] = 4] = "SPOOL_DRAIN";
})(DeviceScopeMask || (DeviceScopeMask = {}));
//# sourceMappingURL=types.js.map